<script>
	import { fly, fade } from 'svelte/transition'
	import { sineInOut } from 'svelte/easing'
	import { loadImage } from '../util/util'
	import next from 'array-next'
	import prev from 'array-previous'

	export let tabs = []

	let height = 0
	let animateheight

	let stiWidth

	let right

	let arrowOffsetRight = 49.5
	let animateTransform

	let activeTab = tabs[0]

	function transitionOut(
		node,
		{
			delay = 0,
			duration = 380,
			easing = sineInOut,
			x = right ? -150 : 150,
			y = 0,
			opacity = 0,
		}
	) {
		const style = getComputedStyle(node)
		const target_opacity = +style.opacity
		const transform = style.transform === 'none' ? '' : style.transform

		const od = target_opacity * (1 - opacity)

		return {
			delay,
			duration,
			easing,
			css: (t, u) => `
			transform: ${transform} translate(${(1 - t) * x}px, ${(1 - t) * y}px);
			opacity: ${target_opacity - od * u}`,
		}
	}
	function transitionIn(
		node,
		{
			delay = 0,
			duration = 380,
			easing = sineInOut,
			x = right ? 150 : -150,
			y = 0,
			opacity = 0,
		}
	) {
		const style = getComputedStyle(node)
		const target_opacity = +style.opacity
		const transform = style.transform === 'none' ? '' : style.transform

		const od = target_opacity * (1 - opacity)

		return {
			delay,
			duration,
			easing,
			css: (t, u) => `
			transform: ${transform} translate(${(1 - t) * x}px, ${(1 - t) * y}px);
			opacity: ${target_opacity - od * u}`,
		}
	}

	function setHeight(node) {
		function update() {
			height = node.clientHeight
			if (!animateheight) {
				setTimeout(() => {
					animateheight = true
				}, 0)
			}
		}
		update()
		return {
			update,
		}
	}

	function updateArrow(node, params) {
		let [tab] = params
		function update() {
			if (tab === activeTab) {
				let nodeMiddleDistanceFromRight = node.offsetLeft + node.clientWidth / 2
				arrowOffsetRight = nodeMiddleDistanceFromRight
				if (!animateTransform) {
					setTimeout(() => {
						animateTransform = true
					}, 0)
				}
			}
		}
		return {
			update,
		}
	}

	function loadImages(tab) {
		if (tab.images) {
			tab.images.forEach(img => loadImage(img))
		}
	}

	let startX

	const touchstart = ({ changedTouches }) => {
		startX = changedTouches[0].pageX
	}
	const touchend = ({ changedTouches }) => {
		const distX = changedTouches[0].pageX - startX
		if (distX < -60) {
			right = 1
			activeTab = next(tabs, activeTab)
		} else if (distX > 60) {
			right = 0
			activeTab = prev(tabs, activeTab)
		}
	}
</script>

{#if tabs.length}
	<div class="sti-btns" bind:clientWidth={stiWidth}>
		{#each tabs as tab, i}
			<button
				class:active={tab === activeTab}
				use:updateArrow={[tab, stiWidth, activeTab]}
				on:mouseenter={() => loadImages(tab)}
				on:click={() => {
					let curIndex = tabs.indexOf(activeTab)
					right = curIndex < i
					activeTab = tab
				}}>
				{tab.name}
			</button>
		{/each}
		<div
			class="arrow"
			style="transform: translateX({arrowOffsetRight}px)"
			class:animateTransform>
			<span>&rsaquo;</span>
		</div>
	</div>

	<div
		class="sti-btns-content"
		style="padding-bottom: {height}px"
		class:animateheight
		on:touchstart={touchstart}
		on:touchend={touchend}>
		{#each [activeTab] as section (section.name)}
			<div
				class="article-formatting"
				use:setHeight={stiWidth}
				in:transitionIn
				out:transitionOut>
				{@html section.content}
			</div>
		{/each}
	</div>

	<div class="sti-lower">
		<div class="sti-lower-link">
			<a href="/request-appointment/" class="pointer-link">
				Request Appointment
			</a>
		</div>
		<div class="sti-images">
			<div class="sti-lower-img">
				{#each activeTab.images.length ? [activeTab.images[0]] : '' as url (url)}
					<div
						style="background-image:url({url})"
						in:fade={{ duration: 350 }}
						out:fade={{ delay: 200, duration: 150 }} />
				{/each}
			</div>
			<div class="sti-lower-img">
				{#each activeTab.images.length > 1 ? [activeTab.images[1]] : '' as url (url)}
					<div
						style="background-image:url({url})"
						in:fade={{ duration: 350 }}
						out:fade={{ delay: 200, duration: 150 }} />
				{/each}
			</div>
		</div>
	</div>
{/if}
